import React from 'react';
import { Check, Target } from 'lucide-react';
import Reveal from '@/components/Reveal';

export default function ServiceDeliverables({ deliverables = [], idealFor = [] }) {
  return (
    <section className="bg-[#0B0B0B] border-t border-white/10 py-20 lg:py-28">
      <div className="max-w-[1320px] mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12 lg:gap-16">
        <Reveal className="lg:col-span-7">
          <span className="text-[11px] font-semibold uppercase tracking-[0.2em] text-[#3B82F6] block mb-4">
            What You Receive
          </span>
          <h2 className="font-display font-bold text-white tracking-tight text-3xl lg:text-4xl leading-tight">
            Scope, contracted in writing
          </h2>
          <ul className="mt-9 space-y-4">
            {deliverables.map((d) => (
              <li key={d} className="flex gap-4 items-start">
                <span className="mt-0.5 w-5 h-5 rounded-full bg-[#2563EB]/15 border border-[#2563EB]/40 flex items-center justify-center shrink-0">
                  <Check className="w-3 h-3 text-[#3B82F6]" />
                </span>
                <span className="text-white/65 font-light leading-relaxed">{d}</span>
              </li>
            ))}
          </ul>
        </Reveal>

        <Reveal delay={0.15} className="lg:col-span-5">
          <div className="rounded-lg border border-white/10 bg-white/[0.03] p-8 lg:p-10">
            <div className="w-11 h-11 rounded-lg bg-[#2563EB]/12 border border-[#2563EB]/30 flex items-center justify-center mb-6">
              <Target className="w-5 h-5 text-[#3B82F6]" />
            </div>
            <h3 className="font-display font-bold text-xl text-white tracking-tight">Ideal engagements</h3>
            <div className="mt-6 space-y-5">
              {idealFor.map((f, i) => (
                <div key={f} className="flex gap-4">
                  <span className="font-display font-bold text-sm text-[#3B82F6]/60 pt-0.5">
                    {String(i + 1).padStart(2, '0')}
                  </span>
                  <p className="text-sm text-white/60 font-light leading-relaxed">{f}</p>
                </div>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}